module.exports = __webpack_public_path__ + "img/confirmation.1aaf309e.svg";